import * as React from 'react';

interface Props {
    returnToLobby: React.EventHandler<React.MouseEvent | React.KeyboardEvent>;
    backButtonVisible: boolean;
}

export const Logo = (props: Props) => {
    const { returnToLobby, backButtonVisible } = props;
    return (
        <button type="button" className={`logo ${!backButtonVisible && 'logo-no-btn-back'}`} onClick={returnToLobby}>
            <img id="chumba-logo" src="/images/header/logo.svg" alt="Chumba Casino" />
        </button>
    );
};
